import { daysOfTheWeekS, generalHelpers, months } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { HTHActivityService } from './HTHActivity2Service';
import { typeHTHTerritory, typePublicMinistryMonthlyService, typePublicMinistryService } from '@monorepo/models';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    day: number;
    hthTerritories: typeHTHTerritory[];
    monthlyService: typePublicMinistryMonthlyService;
    services: typePublicMinistryService[];
    setHthTerritories: Dispatch<SetStateAction<typeHTHTerritory[] | null>>;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const HTHActivityDay: FC<propsType> = ({
    day, hthTerritories, monthlyService, services, setHthTerritories, setRefreshCounter
}) => {
    const [isShowing, setIsShowing] = useState(false);
    const date = generalHelpers.GetDateFromDateString(`${monthlyService.year}-${monthlyService.month + 1}-${day.toString().padStart(2, '0')}`);
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    //
    const completionDate = date.getTime();

    return (
        <div className={'card my-2'}>
            <div className={`card-header bg-secondary text-white ${true ? ' border-bottom' : ''} ${!!services.length ? 'pointer' : ''}`}
                onClick={() => services.length ? setIsShowing(x => !x) : null}
            >
                {daysOfTheWeekS[date.getDay()].toUpperCase()} {day} DE {months[monthlyService.month].toUpperCase()} <span className={isMobile ? 'small' : ''} style={{ fontSize: '.9rem' }}>- SALIDAS{isMobile ? '' : ' DE CASA EN CASA'}: {services.length}</span>
            </div>
            {isShowing &&
                <div className={`card-body ${isDarkMode ? 'bg-dark' : 'bg-lightgrey'} border border-secondary p-0 pb-2 m-0`}>
                    {!!services.length && services.map((s, i) =>
                        <HTHActivityService key={s.id}
                            completionDate={completionDate}
                            day={day}
                            hthTerritories={hthTerritories}
                            monthlyService={monthlyService}
                            service={s}
                            services={services}
                            setHthTerritories={setHthTerritories}
                            setRefreshCounter={setRefreshCounter}
                        />
                    )}
                </div>
            }
        </div>
    );
}
